import React, { useEffect, useState } from "react";
import { Badge } from "react-bootstrap";

import HttpManager from "../../../../services/HttpManager";
import TiraDeMeses from "../../../../components/acuerdos/tiraDeMeses";
import AccionesAlumno from "../../../../components/enrollment/accionesAlumno";
import { useEnviarAprobacion, useTieneCaja } from "../../../../components/aprobaciones/enviarAprobacion";
import { MIN_MOTIVO } from "../../../../components/aprobaciones/tipos";
import { fechaHoraAmPm } from "../../../../utils/fechaHoraAmPm";
import { tituloEstado } from "../../../../utils/tituloEstado";
import { errorText } from "../../managment/enrollmentRequests/helpers";
import { Curso, Dato, Seccion, Sub, Ventana } from "./detallePromo";
import { conPorcentaje, fecha } from "./formato";

/*
	Acuerdos por Matrícula en Promociones (Módulos Claros, 2026-11-01; antes Descuentos › Acuerdos). La fila abre esta ventana como las
	demás de Promociones: datos, grupo, tira de meses e historial en una línea por evento. «Anular» y «Aprobar de Todos Modos» piden el
	motivo y pasan por la ventana «Qué Va a Pasar» (aprobaciones/_preview simula de verdad y enseña cada mensualidad que cambia): quien
	puede hacerlo directo confirma ahí; Caja lo manda a aprobación. El servidor decide quién ve cada acuerdo (la asesora, solo los suyos).
*/

const http = HttpManager.getInstance();

export interface AcuerdoRow {
	id: number; studentId: number; name: string; identityCode?: string | null; enrollmentId: number; courseName?: string | null; scheduleName?: string | null;
	promoName: string; roleName?: string | null; statusId: number; status: string; requestId?: number | null; createdAt?: string | null; omitted?: number;
	advisors?: { userId?: number | null; name: string; sharePercentage?: number | null }[];
}

/** Vigente en naranja; lo que pide atención (pendiente de adelanto, perdido, anulado) en oro; lo terminado en gris. */
export const estadoAcuerdo = (statusId: number, status: string) => {
	const bg = statusId === 1 ? "primary" : [2, 4, 5].includes(statusId) ? "oro" : "secondary";
	return <Badge bg={bg} style={{ fontWeight: 500 }}>{tituloEstado(status)}</Badge>;
};

const DetalleAcuerdo: React.FC<{ campusId: number; row: AcuerdoRow; sym: string; onClose: () => void; onChanged: () => void }> = ({ campusId, row, sym, onClose, onChanged }) => {
	const [d, setD] = useState<any>(null);
	const [error, setError] = useState<string | null>(null);
	const [vuelta, setVuelta] = useState<number>(0);
	const [pidiendo, setPidiendo] = useState<"anular" | "excepcion" | null>(null);
	const [motivo, setMotivo] = useState<string>("");
	const tieneCaja = useTieneCaja();
	const ap = useEnviarAprobacion(campusId);

	useEffect(() => {
		let vigente = true;
		http.paymentService.agreement(campusId, row.id).then((r: any) => { if (vigente) setD(r.data); }).catch((e: any) => { if (vigente) setError(errorText(e)); });
		return () => { vigente = false; };
	}, [campusId, row.id, vuelta]);

	const vivo = d && [1, 2, 3].includes(Number(d.statusId));
	const puedeAnular = !!d && (d.canCancel || (tieneCaja && vivo));
	const puedeExcepcion = !!d && !!d.blocked && !d.exception && (d.canApproveException || tieneCaja);
	const listo = () => { setPidiendo(null); setMotivo(""); setVuelta((v) => v + 1); onChanged(); };
	const continuar = () => {
		if (!d || motivo.trim().length < MIN_MOTIVO) return;
		const reason = motivo.trim();
		if (pidiendo === "anular") {
			ap.pedir({ kind: "anular_acuerdo", titulo: "Anular «" + d.promoName + "»", motivoInicial: reason, data: { agreementId: d.id, reason }, onDone: listo });
		} else if (pidiendo === "excepcion") {
			ap.pedir({ kind: "excepcion_promo", titulo: "Aprobar de Todos Modos", motivoInicial: reason, data: { agreementId: d.id, reason }, onDone: listo });
		}
	};

	return (
		<>
			{ap.modal}
			<Ventana onClose={onClose} titulo={<>
				<span>Acuerdo #{row.id} · {row.name}</span>
				{estadoAcuerdo(d ? Number(d.statusId) : row.statusId, d ? d.status : row.status)}
			</>} pie={d ? (pidiendo ? <>
				<input className="form-control form-control-sm" style={{ flex: "1 1 260px", minHeight: 36 }} autoFocus value={motivo} placeholder="Motivo (Mínimo 10 Letras)" onChange={(e) => setMotivo(e.target.value)} />
				<button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => { setPidiendo(null); setMotivo(""); }}>Atrás</button>
				<button type="button" className="btn btn-primary btn-sm" disabled={motivo.trim().length < MIN_MOTIVO} onClick={continuar}>Continuar</button>
			</> : <>
				<AccionesAlumno studentId={d.studentId} campusId={campusId} alinear="inicio" />
				<span style={{ flex: 1 }} />
				{puedeExcepcion ? <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => setPidiendo("excepcion")}>Aprobar de Todos Modos</button> : null}
				{puedeAnular ? <button type="button" className="btn btn-outline-secondary btn-sm" onClick={() => setPidiendo("anular")}>Anular</button> : null}
			</>) : null}>
				{error ? <div className="alert alert-danger">{error}</div> : !d ? <div className="loader" /> : <>
					{d.endReason ? <div className="wpmAvisoOro"><b>{tituloEstado(d.status)}</b>{d.endedAt ? " · " + fechaHoraAmPm(d.endedAt) : ""}<div>{d.endReason}</div></div> : null}
					{d.blocked && !d.exception ? <div className="wpmAvisoOro">{d.blocked}</div> : null}
					{d.exception ? <div className="wpmAvisoOro"><b>Excepción Aprobada</b> · {d.exception.by} · {fechaHoraAmPm(d.exception.at)}<div>{d.exception.reason}</div></div> : null}
					<div className="wpmDatos">
						<Dato t="Promoción">{d.promoName}{d.roleName ? <Sub>{tituloEstado(d.roleName)}</Sub> : null}</Dato>
						<Dato t="Matrícula"><Curso curso={row.courseName} horario={row.scheduleName} /></Dato>
						<Dato t="Vendido Por">{(row.advisors || []).length ? (row.advisors || []).map((a, i) => <div key={"as" + i} className="wpmAsesora">{conPorcentaje(a)}</div>) : "Sin Vendedor"}</Dato>
						<Dato t="Fecha">{fecha(row.createdAt) || "-"}{d.requestId ? <Sub>Solicitud #{d.requestId}</Sub> : null}</Dato>
						{d.conditions?.text ? <Dato t="Condición">{d.conditions.text}</Dato> : null}
					</div>
					{(d.members || []).length ? (
						<Seccion t="Grupo">
							{d.members.map((m: any, i: number) => (
								<div key={"m" + i} className="wpmEvento"><b>{m.name}</b> <span className="wpmSub" style={{ display: "inline" }}>· {tituloEstado(m.roleName)}{m.left ? " · Salió" : ""}</span></div>
							))}
						</Seccion>
					) : null}
					<Seccion t="Mensualidades">
						<TiraDeMeses meses={d.months.map((m: any) => ({ n: m.n, title: m.title, state: m.statusId === 2 ? "pagado" : m.state, subTotal: m.subTotal, list: m.list, note: m.applied === "omitido" ? m.note : null }))} sym={sym} />
						{d.months.filter((m: any) => m.applied === "omitido").map((m: any) => <div key={"o" + m.tuitionId} className="waOroTexto" style={{ fontSize: 13 }}>{m.title}: {m.note}</div>)}
					</Seccion>
					{(d.events || []).length ? (
						<Seccion t="Historial">
							{d.events.map((e: any, i: number) => (
								<div key={"e" + i} className="wpmEvento"><span className="wpmSub" style={{ display: "inline" }}>{fechaHoraAmPm(e.at)}</span> {e.notes}<span className="wpmSub" style={{ display: "inline" }}> · {(e.by || "").trim() || "Sistema"}</span></div>
							))}
						</Seccion>
					) : null}
				</>}
			</Ventana>
		</>
	);
};

export default DetalleAcuerdo;
